import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromCart } from "./CartActions";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./style/cart.css";
import { getUserPrice } from "./PriceUtlis";
import config from "../../config";

const Cart = () => {
  const dispatch = useDispatch();
  let cartdata = localStorage.getItem("cartdata");
  console.log(cartdata);
  const [cart, setCart] = useState([]);
  // const cart = useSelector((state) => state.cart.cart);
  const ourSelectedCurrency =
    cart.length > 0 ? cart[0].preferredCurrency : "AED";

  // const calculateTotal = () => {
  //   const subtotal = cart.reduce((total, item) => {
  //     return total + parseFloat(item.tourtotal || 0);
  //   }, 0);

  //   const tax = 0;
  //   const fullTotal = subtotal;

  //   return {
  //     subtotal,
  //     tax,
  //     fullTotal,
  //   };
  // };

  const calculateTotal = () => {
    let totalAED = 0;
    let totalUSD = 0;
    const rate = 3.67;

    cart.forEach((item) => {
      const amount = parseFloat(item.tourtotal || 0);

      if (item.preferredCurrency === "AED") {
        totalAED += amount;
      } else if (item.preferredCurrency === "USD") {
        totalUSD += amount;
      }
    });

    const usdToAed = totalUSD * rate;
    const grandTotalAED = totalAED + usdToAed;

    return {
      totalAED,
      totalUSD,
      usdToAed,
      grandTotalAED,
      rate,
    };
  };

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [cartCount, setCartCount] = useState("");
  const [expandedItemIndex, setExpandedItemIndex] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetch(`${config.baseUrl}/welcome`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())

        .then((data) => {
          setIsLoggedIn(true);
        })

        .catch((error) => {
          console.error("Error fetching user data:", error);
        });
    }
  }, []);
  useEffect(() => {
    // Fetch cart data from localStorage when the component mounts
    const storedCart = localStorage.getItem("cartdata");
    if (storedCart) {
      setCart(JSON.parse(storedCart));
    }
  }, []);

  const handleRemoveFromCart = (itemIndex) => {
    // Remove item from the cart
    const updatedCart = cart.filter((_, index) => index !== itemIndex);
    setCart(updatedCart);

    // If the removed item was the one that was expanded, setExpandedItemIndex(null);
    if (expandedItemIndex !== null && expandedItemIndex === itemIndex) {
      setExpandedItemIndex(null);
    }

    // Update localStorage with the modified cart
    localStorage.setItem("cartdata", JSON.stringify(updatedCart));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adding leading zero if needed
    const day = date.getDate().toString().padStart(2, "0"); // Adding leading zero if needed

    return `${year}-${day}-${month}`;
  };

  console.log("Cart Data:", cart);

  return (
    <div className="CartPageContent">
      <div className="container">
        <div className="CartPageContentWrapper">
          <div className="CartPageContenLHS">
            {cart && Array.isArray(cart) && cart.length === 0 ? (
              <div className="EmptyCartMessage">Your cart is empty</div>
            ) : (
              cart.map((item, index) => (
                <div key={index} className="CartBoxWrapper">
                  <div className="CartTopBox">
                    <div className="CartimgWrapper">
                      <img
                        src={`${config.imageUrl}/${item.tourImage}`}
                        alt={item.tourName}
                      />
                    </div>
                    {/*CartimgWrapper*/}
                    <div className="CartContentWrapper">
                      <h4>{item.tourName}</h4>
                      <div className="Price">
                        {isLoggedIn ? (
                          <div className="aedtext">
                            {item.preferredCurrency === "AED" ? (
                              <strong>
                                {/* {item.preferredCurrency}{" "}
                                {particularItemPriceAed(item)} */}
                                {item.preferredCurrency} {item.tourtotal}
                              </strong>
                            ) : (
                              <strong>
                                {/* {item.preferredCurrency}{" "}
                                {particularItemPriceUsd(item)} */}
                                {item.preferredCurrency} {item.tourtotal}
                              </strong>
                            )}
                          </div>
                        ) : (
                          <div className="aedtext">
                            {item.preferredCurrency === "AED" ? (
                              <strong>
                                {/* {item.preferredCurrency}{" "}
                                {particularItemPriceAed(item)} */}
                                {item.preferredCurrency} {item.tourtotal}
                              </strong>
                            ) : (
                              <strong>
                                {/* {item.preferredCurrency}{" "}
                                {particularItemPriceUsd(item)} */}
                                {item.preferredCurrency} {item.tourtotal}
                              </strong>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="BtnGroup">
                        <Link
                          href="#"
                          className="cta BookingInfoCta"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapseExample${index}`}
                          aria-expanded={expandedItemIndex === index}
                          aria-controls={`collapseExample${index}`}
                          onClick={() => setExpandedItemIndex(index)}
                        >
                          Booking Info
                        </Link>
                      </div>
                      <div className="EditTrashGroup">
                        {/*   <div className="Edit" />*/}
                        <div
                          onClick={() => handleRemoveFromCart(index)}
                          className="Trash"
                        />
                      </div>
                      {/*EditTrashGroup*/}
                    </div>
                    {/*CartContentWrapper*/}
                  </div>
                  {/*CartTopBox*/}
                  <div className="CartBottomBox">
                    <div className="collapse" id={`collapseExample${index}`}>
                      <div className="BookingInfoData">
                        <div className="heading">Booking Info</div>
                        <div className="BookingInfotableData">
                          <div className="BookingInfotableDiv">
                            <div className="BookingInfotablerow">
                              <span>Tour Date</span>
                              <span>{formatDate(item.tourDate)}</span>
                            </div>

                            <div className="BookingInfotablerow">
                              <span>Pickup Location</span>
                              <span>
                                {item.preferredPickupLocation ===
                                "Hotel/Apartment" ? (
                                  <>
                                    {item.preferredPickupLocation} <br />
                                    {
                                      item.pickup_location_details?.hotel_name
                                    },{" "}
                                    {
                                      item.pickup_location_details
                                        ?.hotel_address
                                    }
                                    ,{" "}
                                    {
                                      item.pickup_location_details
                                        ?.hotel_telephone
                                    }
                                  </>
                                ) : item.preferredPickupLocation ===
                                  "Restaurant" ? (
                                  <>
                                    {item.preferredPickupLocation} <br />
                                    {
                                      item.pickup_location_details
                                        ?.restaurant_name
                                    }
                                    ,{" "}
                                    {
                                      item.pickup_location_details
                                        ?.restaurant_address
                                    }
                                    ,{" "}
                                    {
                                      item.pickup_location_details
                                        ?.restaurant_telephone
                                    }
                                  </>
                                ) : item.preferredPickupLocation ===
                                  "Local Residence" ? (
                                  <>
                                    {item.preferredPickupLocation} <br />
                                    {
                                      item.pickup_location_details
                                        ?.residence_address
                                    }
                                    ,{" "}
                                    {
                                      item.pickup_location_details
                                        ?.residence_telephone
                                    }
                                  </>
                                ) : item.preferredPickupLocation ===
                                    "DXB Airport Terminal 1" ||
                                  item.preferredPickupLocation ===
                                    "DXB Airport Terminal 2" ||
                                  item.preferredPickupLocation ===
                                    "DXB Airport Terminal 3" ||
                                  item.preferredPickupLocation ===
                                    "DWC Airport" ||
                                  item.preferredPickupLocation ===
                                    "Abu Dhabi Airport" ? (
                                  <>
                                    {item.preferredPickupLocation} <br />
                                    {
                                      item.pickup_location_details
                                        ?.flight_name_number
                                    }
                                    ,{" "}
                                    {item.pickup_location_details?.arrival_time}
                                    ,{" "}
                                    {
                                      item.pickup_location_details
                                        ?.departure_time
                                    }
                                  </>
                                ) : item.preferredPickupLocation ===
                                    "Dubai Cruise Ship Terminal" ||
                                  item.preferredPickupLocation ===
                                    "Abu Dhabi Cruise Ship Terminal" ? (
                                  <>
                                    {item.preferredPickupLocation} <br />
                                    {item.pickup_location_details?.ship_name}
                                  </>
                                ) : (
                                  item.preferredPickupLocation
                                )}
                              </span>
                            </div>

                            {/* <div className="BookingInfotablerow">
                              <span>Hotel Name</span>
                              <span>{item.preferredHotelName}</span>
                            </div> */}
                            {/*BookingInfotablerow*/}
                            <div className="BookingInfotablerow">
                              <span>Preferred Language</span>
                              <span>{item.preferredGuideLanguage}</span>
                            </div>

                            <div className="BookingInfotablerow">
                              <span>Tour Base Price</span>
                              <span>
                                {item.preferredCurrency}{" "}
                                {parseFloat(item.basePrice || 0).toFixed(2)}
                              </span>
                            </div>

                            {/*BookingInfotablerow*/}
                            <div className="BookingInfotablerow">
                              <span>Adults</span>
                              <span>{item.adults}</span>
                            </div>
                            <div className="BookingInfotablerow">
                              <span>Extra Adults Price</span>
                              <span>
                                {item.preferredCurrency} {item.extraAdultPrice}
                              </span>
                            </div>
                            {/*BookingInfotablerow*/}
                            <div className="BookingInfotablerow">
                              <span>Children</span>
                              <span>{item.children}</span>
                            </div>
                            <div className="BookingInfotablerow">
                              <span>Extra Children Price</span>
                              <span>
                                {item.preferredCurrency}{" "}
                                {item.extraChildrenPrice}
                              </span>
                            </div>
                            <div className="BookingInfotablerow">
                              <span>Additional Driver</span>
                              {/* <span>{item.preferredDriver}</span> */}
                              <span>
                                {" "}
                                {item.additional_driver?.toLowerCase() === "yes"
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                            <div className="BookingInfotablerow">
                              <span>Driver Price</span>
                              <span>
                                {item.preferredCurrency} {item.driverTotalPrice}
                              </span>
                            </div>
                            <div className="BookingInfotablerow">
                              <span>Additional Lunch</span>
                              {/* <span>{item.preferredLunc}</span> */}
                              <span>
                                {" "}
                                {item.additional_lunch?.toLowerCase() === "yes"
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                            <div className="BookingInfotablerow">
                              <span>Lunch Price</span>
                              <span>
                                {item.preferredCurrency} {item.lunchPrice}
                              </span>
                            </div>
                            {/*BookingInfotablerow*/}
                          </div>
                          {/*BookingInfotableDiv*/}
                          <div className="BookingInfotableDiv">
                            <div className="BookingInfotablerow">
                              <span>Preferred Pickup Time</span>

                              <span>{item.preferredPickupTime}</span>
                            </div>
                            {/*BookingInfotablerow*/}
                            <div className="BookingInfotablerow">
                              <span>End Location</span>
                              <span>
                                {item.preferredEndLocation ===
                                "Any Other Places in Dubai" ? (
                                  <>
                                    {item.preferredEndLocation}
                                    <br />
                                    {
                                      item.end_location_details?.place_name
                                    },{" "}
                                    {item.end_location_details?.place_address},{" "}
                                    {item.end_location_details?.place_telephone}
                                  </>
                                ) : item.preferredEndLocation ===
                                  "Hotel/Apartment" ? (
                                  <>
                                    {item.preferredEndLocation}
                                    <br />
                                    {
                                      item.end_location_details?.hotel_name
                                    },{" "}
                                    {item.end_location_details?.hotel_address},{" "}
                                    {item.end_location_details?.hotel_telephone}
                                    ,{" "}
                                  </>
                                ) : item.preferredEndLocation ===
                                  "Restaurant" ? (
                                  <>
                                    {item.preferredEndLocation}
                                    <br />
                                    {item.end_location_details?.restaurant_name}
                                    ,{" "}
                                    {
                                      item.end_location_details
                                        ?.restaurant_address
                                    }
                                    ,{" "}
                                    {
                                      item.end_location_details
                                        ?.restaurant_telephone
                                    }
                                  </>
                                ) : item.preferredEndLocation ===
                                  "Local Residence" ? (
                                  <>
                                    {item.preferredEndLocation}
                                    <br />
                                    {
                                      item.end_location_details
                                        ?.residence_address
                                    }
                                    ,{" "}
                                    {
                                      item.end_location_details
                                        ?.residence_telephone
                                    }
                                  </>
                                ) : item.preferredEndLocation ===
                                    "DXB Airport Terminal 1" ||
                                  item.preferredEndLocation ===
                                    "DXB Airport Terminal 2" ||
                                  item.preferredEndLocation ===
                                    "DXB Airport Terminal 3" ||
                                  item.preferredEndLocation === "DWC Airport" ||
                                  item.preferredEndLocation ===
                                    "Abu Dhabi Airport" ? (
                                  <>
                                    {item.preferredEndLocation}
                                    <br />
                                    {
                                      item.end_location_details
                                        ?.flight_name_number
                                    }
                                    , {item.end_location_details?.arrival_time},{" "}
                                    {item.end_location_details?.departure_time}
                                  </>
                                ) : item.preferredEndLocation ===
                                    "Dubai Cruise Ship Terminal" ||
                                  item.preferredEndLocation ===
                                    "Abu Dhabi Cruise Ship Terminal" ? (
                                  <>
                                    {item.preferredEndLocation}
                                    <br />
                                    {item.end_location_details?.ship_name}
                                  </>
                                ) : (
                                  item.preferredEndLocation
                                )}
                              </span>
                            </div>

                            {/* <div className="BookingInfotablerow">
                              <span>Preferred Language Price</span>
                              <span>
                                {item.preferredCurrency} {item.languagePrice}
                              </span>
                            </div> */}

                            <div className="BookingInfotablerow">
                              <span>Guide Base Price</span>
                              <span>
                                {item.preferredCurrency}{" "}
                                {item.languageBasePrice}
                              </span>
                            </div>

                            {parseInt(item.extraLanguagePax) > 0 && (
                              <div className="BookingInfotablerow">
                                <span>Extra Language Pax</span>
                                <span>
                                  {item.extraLanguagePax} ×{" "}
                                  {item.preferredCurrency}{" "}
                                  {item.languageExtraPrice}={" "}
                                  {item.preferredCurrency}{" "}
                                  {(
                                    item.extraLanguagePax *
                                    item.languageExtraPrice
                                  ).toFixed(2)}
                                </span>
                              </div>
                            )}

                            <div className="BookingInfotablerow">
                              <span>Total Guide Price</span>
                              <span>
                                {item.preferredCurrency} {item.languagePrice}
                              </span>
                            </div>

                            {/*BookingInfotablerow*/}
                            <div className="BookingInfotablerow">
                              <span>Pref.currency</span>
                              <span>{item.preferredCurrency}</span>
                            </div>

                            {/*BookingInfotablerow*/}
                            <div className="BookingInfotablerow">
                              <span>Infants</span>
                              <span>{item.infants}</span>
                            </div>
                            <div className="BookingInfotablerow">
                              <span>Infants Price</span>
                              <span>
                                {item.preferredCurrency} {item.infantsPrice}
                              </span>
                            </div>
                            {/*BookingInfotablerow*/}
                            <div className="BookingInfotablerow">
                              <span>Payment Mode</span>
                              {/* <span>{item.preferredPay}</span> */}
                              <span>
                                {item.preferredPay === "card"
                                  ? "Pay By Card"
                                  : "Pay By Cash"}
                              </span>
                            </div>

                            <div className="BookingInfotablerow">
                              <span>Special Request</span>
                              <span>{item.specialRequest || "None"}</span>
                            </div>

                            {/* <div className="BookingInfotablerow">
                              <span>Itinerary Name</span>
                              <span>{item.itinerary_name}</span>
                            </div> */}
                            {/* <div className="BookingInfotablerow">
                              <span>Itinerary Price</span>
                              <span>{item.preferredCurrency} {item.additionalTickets}</span>
                            </div> */}
                            {/*BookingInfotablerow*/}
                          </div>
                          {/*BookingInfotableDiv*/}
                        </div>
                        {/*BookingInfotableData*/}
                      </div>
                      {/*BookingInfoData*/}
                    </div>
                  </div>
                  {/*CartBottomBox*/}
                </div>
              ))
            )}
          </div>

          <div className="CartPageContenRHS">
            {cart && Array.isArray(cart) && cart.length > 0 && (
              <div className="OrderSummaryDiv">
                <div className="heading">Order Summary</div>
                <div className="OrderSummaryTable">
                  <div className="OrderSummaryTablebody">
                    {/* <div className="OrderSummaryTablerow">
                      <span>Subtotal</span>
                      <span>
                        {ourSelectedCurrency}{" "}
                        <strong>
                          {calculateTotal().subtotal.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </strong>
                      </span>
                    </div>
                    <div className="OrderSummaryTablerow">
                      <span>Tax (0%)</span>
                      <span>
                        {ourSelectedCurrency}{" "}
                        <strong>
                          {calculateTotal().tax.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </strong>
                      </span>
                    </div> */}

                    {/* <div className="OrderSummaryTablerow">
                      <span>Order total</span>
                      <span>
                        {ourSelectedCurrency}{" "}
                        <strong>
                          {calculateTotal().fullTotal.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </strong>
                      </span>
                    </div> */}
                    {(() => {
                      const totals = calculateTotal();
                      return (
                        <>
                          <div className="OrderSummaryTablerow">
                            <span>AED Tours Total</span>
                            <span>
                              AED <strong>{totals.totalAED.toFixed(2)}</strong>
                            </span>
                          </div>

                          <div className="OrderSummaryTablerow">
                            <span>USD Tours Total</span>
                            <span>
                              USD <strong>{totals.totalUSD.toFixed(2)}</strong>
                            </span>
                          </div>

                          <div className="OrderSummaryTablerow">
                            <span>Exchange Rate</span>
                            <span>1 USD = {totals.rate} AED</span>
                          </div>

                          <div className="OrderSummaryTablerow">
                            <span>USD Converted to AED</span>
                            <span>
                              {totals.totalUSD.toFixed(2)} × {totals.rate} = AED{" "}
                              <strong>{totals.usdToAed.toFixed(2)}</strong>
                            </span>
                          </div>

                          <hr />

                          <div className="OrderSummaryTablerow">
                            <span>
                              <b>Final Order Total</b>
                            </span>
                            <span>
                              AED{" "}
                              <strong>{totals.grandTotalAED.toFixed(2)}</strong>
                            </span>
                          </div>
                        </>
                      );
                    })()}

                    {/* <div className="OrderSummaryTablerow">
                        <span>Tax (18%)</span>
                        <span>
                          {ourSelectedCurrency}{" "}
                          <strong>
                            {calculateTotal().total.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </strong>
                        </span>
                      </div>
                      <div className="OrderSummaryTablerow">
                        <span>Order total</span>
                        <span>
                          {ourSelectedCurrency}{" "}
                          <strong>
                            {calculateTotal().fullTotal.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </strong>
                        </span>
                      </div> */}
                    <div className="ProceedCheckoutCta">
                      <Link to="/billing-detail" className="cta">
                        Proceed to Checkout
                      </Link>
                    </div>
                    <div className="PaymentMethodGroup">
                      <a href="#">
                        <img src="images/homepage/mastercard.png" alt="" />
                      </a>
                      <a href="#">
                        <img src="images/homepage/visacard.png" alt="" />
                      </a>
                      <a href="#">
                        <img src="images/homepage/rupaycard.png" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
